module.exports = __webpack_public_path__ + "static/media/rightarrowClr.f00f670b.svg";